// Same formula as server/modules/character/rankingRules.statPower; parity is tested on both implementations.
const number=(value:unknown)=>Number.isFinite(Number(value))?Math.max(0,Number(value)):0;
export function hudStatPower(stats:any={}) {
  return Math.floor(number(stats.str)+number(stats.agi)+number(stats.sta)+
    (number(stats.maxHp)+number(stats.maxChakra)+number(stats.defense))/10+
    (number(stats.minAttack)+number(stats.maxAttack))/2);
}
